export class SuggestionItemsMapper {

  constructor() { }

  public map(obj: any) {
    return obj.map(item => {
      return {
        id: item.id,
        name: item.fullAddress
      };
    });
  }
}
